import React, { useEffect } from 'react'
import { Button } from '@/components/Button/Button'
import { useQuizStore } from '@/store/useQuizStore'
import { PlusSvgIcon, TickSvgIcon } from './Icons'
import { clsx } from 'clsx'

export const CheckboxButtons = ({
  data,
  onValid,
}: {
  data: any
  onValid?: (val: boolean) => void
}) => {
  const toggleMulti = useQuizStore((s) => s.toggleMulti)
  const currentValue = useQuizStore((s) => s.getAnswer(data.name))
  const clearAnswer = useQuizStore((s) => s.clearAnswer)

  const handleClick = (e: React.MouseEvent, value: string, clearAll: boolean) => {
    e.preventDefault()
    if (!data?.name) return

    if (clearAll) {
      clearAnswer(data.name)
      toggleMulti(data.name, value)
    } else {
      const hasClearAll = data?.items?.find((i: any) => i.clearAll)
      if (hasClearAll && currentValue?.includes(hasClearAll.title)) {
        clearAnswer(data.name)
      }
      toggleMulti(data.name, value)
    }
  }

  useEffect(() => {
    onValid && onValid(currentValue !== undefined && currentValue?.length !== 0)
  }, [currentValue])

  return (
    <div className="mt-9">
      {data?.items?.map((el: any, i: number) => {
        const value = el.title
        const active = data?.name ? currentValue?.includes(value) : false
        return (
          <Button
            key={el.title + i}
            onClick={(e) => handleClick(e, value, el.clearAll ?? false)}
            aria-pressed={active}
            className={clsx(
              { 'bg-lightPrimary': active, 'bg-boxBg': !active },
              '  mt-3 whitespace-normal border-0 rounded-[24px] text-left font-semibold justify-start p-4 gap-4 text-text  pr-14 relative transition-all duration-200',
            )}
          >
            <span
              className={clsx(
                { 'opacity-1': active, 'opacity-0': !active },
                'absolute top-0 left-0 w-full h-full rounded-[24px] pointer-events-none border-buttonGradient border-2 transition-all duration-200',
              )}
            ></span>
            {el.icon && (
              <img
                className="min-w-10 max-w-10"
                src={el.icon}
                alt={el.title}
                width={40}
                height={40}
              />
            )}

            {el.title}
            {el?.description && el?.description}

            {!el?.clearAll && (
              <div
                className={`${active ? ' bg-buttonGradient text-black' : 'bg-boxBg text-text'} flex items-center justify-center transition-all duration-200 absolute top-1/2 -translate-y-1/2 right-[22px] w-8 h-8 rounded-full`}
              >
                {active ? <TickSvgIcon /> : <PlusSvgIcon />}
              </div>
            )}
          </Button>
        )
      })}
    </div>
  )
}
